"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isDismissableClientUpdate = exports.isNotifiedClientUpdate = exports.isDefaultClientUpdate = exports.ClientReleasePriority = void 0;
var ClientReleasePriority;
(function (ClientReleasePriority) {
    ClientReleasePriority["DEFAULT"] = "DEFAULT";
    ClientReleasePriority["LOW"] = "LOW";
    ClientReleasePriority["MEDIUM"] = "MEDIUM";
    ClientReleasePriority["HIGH"] = "HIGH";
    ClientReleasePriority["CRITICAL"] = "CRITICAL";
})(ClientReleasePriority || (exports.ClientReleasePriority = ClientReleasePriority = {}));
const isDefaultClientUpdate = (level) => !level || level === ClientReleasePriority.DEFAULT;
exports.isDefaultClientUpdate = isDefaultClientUpdate;
const isNotifiedClientUpdate = (level) => level === ClientReleasePriority.MEDIUM ||
    level === ClientReleasePriority.HIGH ||
    level === ClientReleasePriority.CRITICAL;
exports.isNotifiedClientUpdate = isNotifiedClientUpdate;
const isDismissableClientUpdate = (level) => level !== ClientReleasePriority.HIGH && level !== ClientReleasePriority.CRITICAL;
exports.isDismissableClientUpdate = isDismissableClientUpdate;
//# sourceMappingURL=clientReleases.js.map